<template>
<div class="guideContainer">
    <img class="bannerImg" src="@/assets/image/guide/banner.png" alt="" />
    <div class="guide-item">
        <div class="guideItemImg">
            <img src="@/assets/image/guide/title1.png" alt="" />
        </div>
        <div class="desc">
            点击相应车辆查看位置信息，
            <span>APP新增当前速度、里程、载重及ACC状态等</span>
            信息，帮助使用者全面掌握人车情况。
        </div>
        <div class="carInfo">
            <img src="@/assets/image/guide/carInfo.png" alt="" />
        </div>
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title2.png" alt="" />
        <div class="gdesc">
            新增OBD信息，
           <span>实时反映当前转速与速度</span>
            ,利于判断车辆实况，辅助规范行车习惯。
        </div>
        <img class="obdImg" src="@/assets/image/guide/obd.png" alt="" />
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title3.png" alt="" />
        <div class="gdesc">
           新增温湿度监控、胎压监控，并有
           <span>报警提醒及详细报警参数</span>
           ，实时判断并确保温湿度、胎压情况正常
        </div>
        <img class="carParamsImg" src="@/assets/image/guide/carParams.png" alt="" />
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title4.png" alt="" />
        <div class="gdesc">
          新增油量数据，图文形式直观了解油耗情况。
          <span>加油数据、漏油数据包含时间、地点、油量等详细信息</span>
          ，帮助车队掌握真实用油，为管理司机提供依据。
        </div>
        <img class="monitorImg" src="@/assets/image/guide/monitor.png" alt="" />
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title5.png" alt="" />
        <div class="gdesc tdesc">
         平台可下发各类指令，包括回传间隔和油电控制，均根据实际情况调整。
        </div>
        <img class="instructImg" src="@/assets/image/guide/instructImg.png" alt="" />
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title6.png" alt="" />
        <div class="gdesc tdesc">
         可开启追踪模式，锁定相应车辆位置，进行实时追踪，并且可以分享给第三方平台。
        </div>
        <div class="moitorDetail">
            <img class="guideImg" src="@/assets/image/guide/guide.png" alt="" />
        </div>
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title7.png" alt="" />
        <div class="gdesc tdesc">
         回放轨迹可展现
         <span>报警点、漏油点、加油点、报警点、停车点</span>
         等重要位置，直观把握行车情况；点击相应轨迹点，具体信息数据一眼便知。
        </div>
        <img class="lineImg" src="@/assets/image/guide/line.png" alt="" />
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title8.png" alt="" />
        <div class="gdesc sdesc">
        不同的展示方法迎合不同用户的使用习惯，车辆除了在监控页面以地图位置标注，也可以以列表展示，方便您找寻查看具体车辆的各项信息。
        </div>
        <img class="statusImg" src="@/assets/image/guide/carSatus.png" alt="" />
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title9.png" alt="" />
        <div class="gdesc rdesc">
        车智管有专业的报表，统计系统中车辆和司机的各项数据，包括里程、油量、行驶、停车、考勤等，以可视化图表的形式展现。
        </div>
        <img class="reportImg" src="@/assets/image/guide/report.png" alt="" />
        <div class="reportDesc">
            <img src="@/assets/image/guide/calendar.png" alt="" />
            <div>
                车智管以月为周期，统计所有车辆各维度的数据，形成一份全方面的月报，方便管理者对比分析。
            </div>
        </div>
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title10.png" alt="" />
        <div class="illegal tdesc">
            <p>1.支持系统内车辆违章查询；</p>
            <p>2.<span>保险/年检到期/违章消息</span>，车智管通过提醒消息及时通知。</p>
        </div>
        <img class="illegalImg" src="@/assets/image/guide/illeage.png" alt="" />
    </div>
    <div class="guideItem">
        <img src="@/assets/image/guide/title11.png" alt="" />
        <div class="gdesc sdesc">
           如果车辆触发了
           <span>平台、设备、主动安全报警</span>，车智管会通过预警消息及时提醒，您也可查看报警的具体情况。
        </div>
        <img class="illegalImg alarmImg" src="@/assets/image/guide/alarm.png" alt="" />
    </div>
    <img class="bottomImg" src="@/assets/image/guide/bottom.png" alt="" />
</div>
</template>

<script>
export default {
 
}
</script>

<style lang="scss" scoped>
.guideContainer {
    .bannerImg {
        width: 414px;
        height: 327.5px;
        margin-bottom: 24px;
    }

    .guide-item {
        .guideItemImg {
            height: 38px;
            margin-bottom: 16px;
            text-align: center;

            img {
                width: 166.5px;
                height: 100%;
            }
        }

        .desc {
            width: 372px;
            height: 34px;
            margin: 0 auto;
            margin-bottom: 24.5px;
            font-size: 13px;
            color: #2C2E34;
            font-weight: bold;
            line-height: 16px;
            letter-spacing: 0.81px;

            span {
                font-size: 14px;
                color: #00B38A;
            }
        }

        .carInfo {
            width: 365.5px;
            height: 264px;
            margin: 0 auto;
            margin-bottom: 35px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .guideItem{
        text-align: center;
        img{
            width: 166.5px;
            height: 100%;
            margin-bottom: 17px;
        }
        .gdesc{
            width: 362px;
            height: 31px;
            margin:0 auto;
            margin-bottom: 25px;
            font-size: 13px;
            color: #2C2E34;
            font-weight: bold;
            text-align: left;
            line-height: 15.5px;
            letter-spacing: 0.31px;
            span{
                color: #00B38A;
            }
        }
        .obdImg{
            width: 365px;
            height:263.5px;
            margin-bottom: 38px;
        }
        .carParamsImg{
            width: 337.5px;
            height: 300.5px;
        }
        .monitorImg{
            width: 292.5px;
            height: 306.5px;
            margin-bottom: 42px;
        }
        .tdesc{
            margin-bottom: 30px;
        }
        .instructImg{
            width: 362px;
            height: 308px;
            margin-bottom: 40px;
        }
        .moitorDetail{
            text-align: left;
            .guideImg{
                width: 361px;
                height: 300.5px;
                margin-bottom: 35px;
            }
        }
        .lineImg{
            width: 337.5px;
            height: 300.5px;
            margin-bottom: 32px;
        }
        .lineTxt{
            width: 370.5px;
            height: 34.5px;
            box-sizing: border-box;
            padding-left: 26px;
            text-align: left;
            font-size: 13px;
            font-weight: bold;
            color: #2C2E34;
        }
        .date{
            width: 350px;
            height: 315px;
            margin-bottom: 40.5px;
        }
        .sdesc{
            margin-bottom: 25px;
        }
        .statusImg{
            width: 355px;
            height: 305.5px;
            margin-bottom: 40px;
        }
        .rdesc{
            margin-bottom: 29px;
        }
        .reportImg{
            width: 337.5px;
            height: 300.5px;
            margin-bottom: 45.5px;
        }
        .reportDesc{
            width: 375.5px;
            height: 71.5px;
            margin-left: 38.5px;
            margin-bottom: 40px;
            text-align: left;
            img{
                width: 93.5px;
                height: 100%;
                float: left;
                margin-right: 15px;
            }
            div{
                box-sizing: border-box;
                padding-top: 18px;
                padding-right: 18px;
                font-size: 13px;
                font-weight: bold;
                color: #2C2E34;
            }
        }
        .illegal{
            width:370.5px;
            height: 31px;
            margin-left: 26px;
            text-align: left;
            font-size: 13px;
            font-weight: bold;
            color: #2C2E34;
            letter-spacing:0.6px;
            p{
                margin-bottom: 2px;
            }
            span{
                color: #00B38A;
            }
        }
        .illegalImg{
            width: 337.5px;
            height: 300.5px;
            margin-bottom: 40px;
        }
        .alarmImg{
            margin-bottom: 38.5px;
        }
    }
    .bottomImg{
        width: 365px;
        // height: 300px;
    }
}
</style>
